import { h } from 'preact';
import * as BaseComp from 'components/templates/gallery/gallery.js';

import copy from 'copy-to-clipboard';
import { sortObjectByOrder, joinClasses, triggerAnim } from 'utils/utils';

import IconShare from 'components/bolt/icons/share';
import HTML from 'components/core/html/html';
import Transition from 'components/core/transition/transition';
import SimpleVideoPlayer from 'components/shared/simpleVideoPlayer/simpleVideoPlayer';
import Youtube from 'components/shared/youtube/youtube';

import s from 'components/templates/gallery/gallery.sss';

export default class Gallery extends BaseComp.default {

	constructor(props) {
		super(props);
		this.share = this.share.bind(this);
	}

	selectFromHash(hash = location.hash) {
		let [, selection] = hash.split('/');
		if (!selection) {
			return;
		}
		const list = sortObjectByOrder(this.props.data.list);
		const index = list.findIndex(item => item.ytid === selection || item.src?.match(/\/([^/.]+)\.[^/]+$/)?.[1] === selection);
		if (index !== -1) {
			this.navigateAbsolute(index);
		} else if (+selection) {
			this.navigateAbsolute(selection - 1);
		}
	}

	getCurrentHash() {
		// let selected = sortObjectByOrder(this.props.data.list)[this.state.index];
		// let selectedId = selected.ytid || item.src?.match(/\/([^/.]+)\.[^/]+$/)?.[1];
		return [this.props.id, this.state.index + 1].filter(e => e).join('/');
	}

	navigateAbsolute(...args) {
		super.navigateAbsolute(...args);
		this.props.updateHash?.();
	}

	share() {
		let url = location.href;
		if (navigator.share) {
			navigator.share({ url: location.href });
		} else {
			copy(url);
			triggerAnim(this.$share, s.copiedToClipboard);
		}
	}

	paragraph(item) {
		if (!item.title && !item.text) return;
		const copy = this.props.copy;
		return (
			<div class={s.paragraph} id={item.title}>
				{item.title && <HTML tag="h3" markdown class={s.title}>{item.title}</HTML>}
				{item.text && <p class={s.text}>{item.text}</p>}
				<button class={s.share} onClick={this.share} ref={e => e && (this.$share = e)} data-copied-text={copy?.$COPY_LINK_SUCCESS || 'Copy'}>
					<IconShare /><span>{copy?.$SHARE || 'Share'}</span>
				</button>
			</div>
		);
	}

	render({ data, isDesktop, active }, { index }) {
		const {
			list,
			title
		} = data;

		const sortedList = sortObjectByOrder(list);
		const length = sortedList.length;
		const activeItem = sortedList[index];

		return (
			<div class={joinClasses(s.wrapper, active && s.active)} id="gallery" data-section-observed>
				{title && <h3 class={s.title}>{title}</h3>}
				<div class={s.view}>
					{sortedList.map((item, idx) => {
						const position = this.getPosition(idx, index);
						if (item.src?.includes('.mp4')) {
							let playing = this.state[`playing${idx}`];
							return (
								<div key={idx} class={joinClasses(s.relCont, position, s.videoWrapper)} inert={idx !== index}>
									<SimpleVideoPlayer
										class={s.video}
										src={item.src}
										showControls
										ref={ref => this[`$video${idx}`] = ref}
										handlePosterClick={() => this.handlePosterClick(idx, title, item.src)}
									/>
									<div class={joinClasses(s.playBtn, !playing ? s.show : s.hide)} />
									<div class={joinClasses(s.poster, !playing ? s.show : s.hide)} style={{ backgroundImage: `url(${item.poster})` }} onClick={() => this.handlePosterClick(idx, title, item.src)} />
								</div>
							);
						}

						const youtubeId = item?.ytid;
						if (youtubeId) {
							return (
								<div key={idx} class={joinClasses(s.relCont, position, s.videoWrapper)} inert={idx !== index}>
									<Youtube
										ref={ref => this[`$video${idx}`] = ref}
										class={joinClasses(s.videoElement, this.props.class, this.props.className)}
										activeItem={{ ytid: youtubeId }}
										maintainAspectRatio={false}
										autoplay={false}
										responsiveResize
										key={`youtube-${youtubeId}`}
									/>
								</div>
							);
						}

						return (
							<img key={idx} src={item.src} class={joinClasses(s.item, position)} />
						);

					})}
					{length > 1 && (
						<div class={s.controls}>
							<button class={joinClasses(s.btn, s.left)} onClick={this.prev}>{!isDesktop && 'Prev'}</button>
							<div class={s.indicator}>{`${index + 1}/${length}`}</div>
							<button class={joinClasses(s.btn, s.right)} onClick={this.next}>{!isDesktop && 'Next'}</button>
						</div>
					)}
				</div>
				<Transition
					class={s.transition}
					enteringClass={s.entering}
					emptyClass={s.empty}
					visibleClass={s.visible}
					leavingClass={s.leaving}
					duration={1000}
				>
					{this.paragraph(activeItem)}
				</Transition>
			</div>
		);
	}
}
